var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangleRed = function SvgWarningTriangleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD3838",
    fillRule: "evenodd",
    d: "M10.182 4.05c.809-1.4 2.83-1.4 3.637 0l7.535 13.05c.808 1.4-.202 3.15-1.819 3.15H4.466c-1.616 0-2.627-1.75-1.818-3.15zm1.819 3.006a.9.9 0 0 1 .9.9v4.2a.9.9 0 0 1-1.8 0v-4.2a.9.9 0 0 1 .9-.9m0 10.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4",
    clipRule: "evenodd"
  })));
};
export { SvgWarningTriangleRed as ReactComponent };
export default __webpack_public_path__ + "e0556c59f46bf7e8728d61543dd16706.svg";